import "./TrainingAcademy.module.css";
import Header from "@/reusable_sections/Header";
import ManagementSolutions from "./sections/ManagementSolutions";
import StopLosingCustomersSolution from "./sections/StopLosingCustomersSolution";
import StillNeedHelp from "./sections/StillNeedHelp";
import FooterInfo from "@/reusable_sections/Footer";
export default function TrainingAcademyPage() {
  return <div>
      <Header />
      <ManagementSolutions />
      <StopLosingCustomersSolution />
      <StillNeedHelp />
      <FooterInfo />
    </div>;
}